// OperatorList.js
import React, { useRef, forwardRef, useImperativeHandle } from 'react';
import Observed_Opportunity from '../observed_opportunity.js';
import { useTranslation } from 'react-i18next';

const OperatorList = forwardRef(({ operators, vocs, config, onDataChange }, ref) => {
  // Refs for collecting data from all Observed_Opportunity components
  const operatorRefs = useRef([]);

  const { t } = useTranslation('labels');
  // Expose data collection method to parent
  useImperativeHandle(ref, () => ({
    getData: () => {
      // Collect data from all Observed_Opportunity components
      return operatorRefs.current
        .filter(ref => ref)
        .map(ref => ref.getData());
    }
  }));

  return (
    <>
    <div class="accordion" id="accordion-one">
                        <div class="accordion-item">
                            <div class="accordion-header rounded-lg" id="indexGuide" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-controls="collapseOne" aria-expanded="false" role="button">
                                <span class="accordion-header-icon"></span>
                                <span class="accordion-header-text">{t('index', { ns: 'labels' })}</span>
                                <span class="accordion-header-indicator"></span>
                            </div>
                            <div id="collapseOne" class="collapse" aria-labelledby="indexGuide" data-bs-parent="#accordion-one">
                                <div class="accordion-body-text">
                                    <strong>{t('indicationMeaning', { ns: 'labels' })}</strong>
                                    <ul className="mt-2 mb-0">
                                        <li><strong>pr-cont</strong> {t('prContExp', { ns: 'labels' })}</li>
                                        <li><strong>pr-aseps</strong> {t('prAsepsExp', { ns: 'labels' })}</li>
                                        <li><strong>dp-fluido</strong> {t('dpFluidoExp', { ns: 'labels' })}</li>
                                        <li><strong>dp-cont</strong> {t('dpContExp', { ns: 'labels' })}</li>
                                        <li><strong>dp-circ</strong> {t('dpCircExp', { ns: 'labels' })}</li>

                                    </ul>

                                </div>
                            </div>
                        </div>

                    </div>
      <div className="row flex-wrap">
        {operators.map((op, index) => (
          <Observed_Opportunity
            key={op.Observation_items_order}
            ref={el => operatorRefs.current[index] = el}
            operator={op}
            operatorIndex={index}
            vocs={vocs}
            parsedConfig={config}
            onDataChange={onDataChange}
          />
        ))}
      </div>
    </>
  );
});

export default OperatorList;
